// extracted by mini-css-extract-plugin
module.exports = {"section":"TeaserSection_section_2f0NK","logo":"TeaserSection_logo_kJxXC"};